import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import GNB from 'components/GNB';
import { useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useAppDispatch, useAppSelector } from 'store/config';
import { walletService } from 'store/slices/walletSlice';
import MenuToggle from './MenuToggle';
import { CUSTOM_BREAK_POINT } from './Blocks/Block.styled';
import IconDiscord from './IconDiscord';
import IconKakao from './IconKakao';
import IconGitBook from './IconGitBook';
import { Link } from 'react-router-dom';

const Header = () => {
  const isMobile = useAppSelector((state) => state.global.isMobile);
  const isLoggedIn = useAppSelector((state) => state.wallet.isLoggedIn);
  const dispatch = useAppDispatch();
  const isWalletExist = !!window.ethereum;
  const { hash, pathname } = useLocation();

  const METAMASK_DEEP_LINK = `https://metamask.app.link/dapp/${window.location.href}`;

  const [isOpen, setIsOpen] = useState(false);

  const handleConnect = () => {
    if (isMobile) {
      // Mobile : metamask
      if (isLoggedIn) {
        dispatch(walletService.disconnectMetamask());
      } else {
        dispatch(walletService.connectMetamask());
      }
    } else {
      // Desktop : Kaikas
      if (isLoggedIn) {
        dispatch(walletService.disconnectKaikas());
      } else {
        dispatch(walletService.connectKaikas());
      }
    }
  };

  const toggleOpen = () => {
    return setIsOpen(!isOpen);
  };

  return (
    <GNB>
      <RollingBannerWrapper>
        <RollingBanner>
          <p>
            <span>GUMMY NFT MINTING 1ST MARKET OPEN 2022-10-07</span>
          </p>
          <p>
            <span>GUMMY NFT MINTING 1ST MARKET OPEN 2022-10-07</span>
          </p>
          <p>
            <span>GUMMY NFT MINTING 1ST MARKET OPEN 2022-10-07</span>
          </p>
          <p>
            <span>GUMMY NFT MINTING 1ST MARKET OPEN 2022-10-07</span>
          </p>
          <p>
            <span>GUMMY NFT MINTING 1ST MARKET OPEN 2022-10-07</span>
          </p>
          <p>
            <span>GUMMY NFT MINTING 1ST MARKET OPEN 2022-10-07</span>
          </p>
        </RollingBanner>
      </RollingBannerWrapper>
      <HeaderWrapper>
        <a
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '0px 16px',
            flexBasis: '25%',
          }}
          href='/'
        >
          <Logo>
            <img src='/logo.png' alt='logo' />
          </Logo>
        </a>
        <Menu isOpen={isOpen}>
          {/* 전체 */}
          <HashLinkWithAction to='/#story' hash={hash} smooth>
            Story
          </HashLinkWithAction>
          <HashLinkWithAction to='/#benefit' hash={hash} smooth>
            Benefit
          </HashLinkWithAction>
          <HashLinkWithAction to='/#info' hash={hash} smooth>
            Info
          </HashLinkWithAction>
          <HashLinkWithAction to='/#road-map' hash={hash} smooth>
            RoadMap
          </HashLinkWithAction>
          <HashLinkWithAction to='/#faq' hash={hash} smooth>
            FAQ
          </HashLinkWithAction>
          {/* 1차 오픈 */}
          {/* <HashLinkWithAction to='/#landing' hash={hash} smooth>
            Main
          </HashLinkWithAction>
          <HashLinkWithAction to='/#story' hash={hash} smooth>
            Story
          </HashLinkWithAction>
          <StyledLink to='/mint' pathname={pathname}>
            Mint
          </StyledLink> */}
        </Menu>
        <AuthWrapper isOpen={isOpen}>
          {isMobile && !isWalletExist ? (
            <a href={METAMASK_DEEP_LINK}>
              <AuthButton>지갑연결</AuthButton>
            </a>
          ) : (
            <AuthButton onClick={handleConnect}>
              {isLoggedIn ? '연결해제' : '지갑연결'}
            </AuthButton>
          )}
          <HeaderSns>
            <a
              href='https://discord.gg/EfmBNrhsuz'
              target='_blank'
              rel='noreferrer'
            >
              <IconDiscord size={36} />
            </a>
            <a
              href='https://gumand.gitbook.io/gummy/'
              target='_blank'
              rel='noreferrer'
            >
              <IconGitBook size={36} />
            </a>
            <a
              href='https://open.kakao.com/o/gcmWYrFe'
              target='_blank'
              rel='noreferrer'
            >
              <IconKakao size={36} />
            </a>
          </HeaderSns>
        </AuthWrapper>
        <MenuToggle isOpen={isOpen} setOpen={toggleOpen} />
      </HeaderWrapper>
    </GNB>
  );
};

export default Header;

const RollingBannerWrapper = styled.div`
  position: relative;
  height: 40px;
  background-color: #f7aedc;
  width: 100%;

  /* display: flex;
  align-items: center; */
  /* -webkit-box-pack: start;
  justify-content: flex-start; */

  ::after {
    width: 100%;
    height: 5px;
    content: '';
    left: 0;
    bottom: 0;
    background-color: #f8e338;
    position: absolute;
  }
`;

const RollingBanner = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;

  animation: flowing 16s linear infinite;
  transform: translate3d(0px, 0px, 0px);

  @keyframes flowing {
    from {
      transform: translate3d(-90px, 0px, 0px);
    }

    to {
      transform: translate3d(-1000px, 0px, 0px);
    }
  }
  /* flex-wrap: nowrap; */
  /* -webkit-box-pack: start; */
  /* -webkit-box-align: center; */

  p {
    display: flex;
    -webkit-box-align: center;
    gap: 56px;
    padding: 0px 28px;
    white-space: nowrap;
    line-height: 1;
    color: white;

    span {
      color: #4d5ced;
      font-weight: 700;
    }
  }
`;

const HeaderWrapper = styled.nav`
  display: flex;
  height: 88px;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    flex-direction: column;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  width: 201px;
  height: 88px;

  /* padding: 24px 12px; */

  p {
    font-weight: 600;
    font-size: 30px;
    color: #ffffff;
  }

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    width: 100%;
  }
`;

const Menu = styled.ul<{ isOpen: boolean }>`
  display: flex;
  column-gap: 48px;
  row-gap: 10px;
  justify-content: center;
  flex-basis: 50%;
  list-style: none;
  padding-left: 0;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    display: ${(props) => (props.isOpen ? 'flex' : 'none')};
    flex-direction: column;
    align-items: center;
    justify-content: center;

    box-shadow: 0px 2px 11px rgba(113, 113, 113, 0.1);
    background-color: var(--bg-color);

    width: 100%;
  }
`;
const AuthWrapper = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0px 16px;
  height: 100%;
  flex-basis: 25%;

  line-height: 150%;

  list-style: none;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    display: ${(props) => (props.isOpen ? 'flex' : 'none')};
    flex-direction: column;

    width: 100%;
    padding: 15px;

    box-shadow: 0px 2px 11px rgba(113, 113, 113, 0.1);
    background-color: var(--bg-color);
  }
`;

const AuthButton = styled.button`
  padding: 12px 8px;
  font-size: 20px;
  border-radius: 5px;
  /* transition: 0.25s; */
  color: #ffffff;
  /* background-color: #2d2daa; */
  background-color: var(--bg-color);
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-family: 'KoPub', Arial, Helvetica, sans-serif;

  &:active {
    /* transform: scale(1.2); */
  }

  &:hover:enabled {
    color: var(--hover);
  }

  &:disabled {
    cursor: default;
    background-color: rgb(189, 189, 189, 0.1);
  }
`;

const HashLinkWithAction = styled(HashLink)<{ to: string; hash: string }>`
  font-size: 22px;
  letter-spacing: 0.44px;
  text-transform: uppercase;
  font-family: 'Titan One', Arial, Helvetica, sans-serif;
  color: ${({ to, hash }) => (to === `/${hash}` ? 'var(--hover)' : '#ffffff')};

  &:hover {
    color: var(--hover);
  }
`;

const StyledLink = styled(Link)<{ to: string; pathname: string }>`
  font-size: 22px;
  letter-spacing: 0.44px;
  text-transform: uppercase;
  font-family: 'Titan One', Arial, Helvetica, sans-serif;
  color: ${({ to, pathname }) =>
    to === pathname ? 'var(--hover)' : '#ffffff'};

  &:hover {
    color: var(--hover);
  }
`;

const HeaderSns = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  > a {
    display: inline-block;
    margin-left: 10px;
    color: white;
  }
`;
